import { LogOut, Menu } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthProvider'
import { Button } from '../Button'
import { RoleBadge } from '../StatusBadge'

export function Topbar({
  title,
  onMenuClick,
}: {
  title: string
  onMenuClick?: () => void
}) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <header className="h-14 px-3 md:px-6 flex items-center justify-between border-b border-line bg-white shrink-0">
      <div className="flex items-center gap-2 min-w-0">
        <button
          onClick={onMenuClick}
          className="size-8 rounded-md text-slatey hover:bg-ivory hover:text-ink inline-flex items-center justify-center lg:hidden shrink-0"
          aria-label="Open menu"
        >
          <Menu className="size-4" />
        </button>
        <h1 className="font-display text-base font-semibold text-ink truncate">{title}</h1>
      </div>
      <div className="flex items-center gap-1 md:gap-3 shrink-0">
        {user ? (
          <>
            <div className="text-right leading-tight hidden xs:block">
              <p className="text-xs font-medium text-ink">{user.name}</p>
              <RoleBadge role={user.role} />
            </div>
            <Button variant="ghost" size="sm" onClick={handleLogout}>
              <LogOut className="size-3.5" />
              <span className="hidden sm:inline">Logout</span>
            </Button>
          </>
        ) : null}
      </div>
    </header>
  )
}
